export const enum LoaderSizeEnum {
  small = 'small',
  medium = 'medium',
  large = 'large',
}
